import { render, staticRenderFns } from "./duration-panel.vue?vue&type=template&id=4cf33c36&scoped=true"
import script from "./duration-panel.vue?vue&type=script&lang=js"
export * from "./duration-panel.vue?vue&type=script&lang=js"
import style0 from "./duration-panel.vue?vue&type=style&index=0&id=4cf33c36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf33c36",
  null
  
)

export default component.exports